var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C5.376 0 0 5.376 0 12C0 18.624 5.376 24 12 24C18.624 24 24 18.624 24 12C24 5.376 18.624 0 12 0ZM12 21.6C6.708 21.6 2.4 17.292 2.4 12C2.4 6.708 6.708 2.4 12 2.4C17.292 2.4 21.6 6.708 21.6 12C21.6 17.292 17.292 21.6 12 21.6ZM16.2573 14.8674C16.5218 14.4175 17.1138 14.276 17.5546 14.5589C17.9955 14.8417 18.134 15.4331 17.8569 15.8831C16.5722 17.9529 14.3932 19.2 12 19.2C9.60684 19.2 7.42781 17.9658 6.14306 15.8702C5.86596 15.4203 6.00451 14.8289 6.44536 14.546C6.8862 14.2632 7.4656 14.4046 7.7427 14.8546C8.67477 16.3716 10.2618 17.2716 12 17.2716C13.7382 17.2716 15.3252 16.3716 16.2573 14.8674ZM9.6 9C9.6 9.99411 8.79411 10.8 7.8 10.8C6.80589 10.8 6 9.99411 6 9C6 8.00589 6.80589 7.2 7.8 7.2C8.79411 7.2 9.6 8.00589 9.6 9ZM16.2 10.8C17.1941 10.8 18 9.99411 18 9C18 8.00589 17.1941 7.2 16.2 7.2C15.2059 7.2 14.4 8.00589 14.4 9C14.4 9.99411 15.2059 10.8 16.2 10.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile);
export default __webpack_public_path__ + "static/media/smile.aaca89f6.svg";
export { ForwardRef as ReactComponent };